(ns rothko.editor.space.paths
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.paths :as document-paths]))

(defn create-at
  [index]
  [:script
   (sp/before-index index)
   (sp/terminal-val
    {:word " "
     :type :space})])

(defn str-end?
  [{:keys [start-index start-offset end-index end-offset] :as selection}]
  [:script
   (sp/nthpath start-index)
   :word
   (document-paths/offset-to-last start-offset)
   (sp/view count)
   (sp/pred= 0)])

(def SPACE?
  [:type
   (sp/pred= :space)])

(def ^{:doc "Is it a space-edit token?"} SPACE-EDIT?
  [:type
   (sp/pred= :space-edit)])

(defn space?
  [index]
  [:script
   (document-paths/safe-nthpath
    index
    SPACE?)])
